import styled, { css } from "styled-components";
import { ScrollToTopOnMount, parseCSS } from "scripts/FunctionsBundle";
import {
  Form,
  useLoaderData,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import * as _T from "@utils/ClassTypes";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { GS } from "App";
import UsuariosForms from "@components/UsuariosForms";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// AdminAction => Rename all instances to use
type AdminActionProps = {} & _Base;

const actions = {
  new: "Crear ",
  edit: "Editar ",
  delete: "Eliminar ",
};

// ################################ RENDERING COMPONENT ################################
const _AdminAction = (props: AdminActionProps) => {
  const { id, action } = useParams();
  const { el } = useLoaderData() as { el: _T.Usuario };
  const navigate = useNavigate();

  // ------------------------------------------------------------------------------------ LS STATE
  const [LS] = useState(el);
  const nav = useNavigation();

  // ------------------------------------------------------------------------------------ CLEAN UP CACHE
  useEffect(() => {
    return () => {
      GS.cache = {};
    };
  }, []);

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <div className={props.className + " screen"}>
      <Helmet>
        <title>
          {actions[action || "new"] + "usuarios: <" + id + ">"} | RSA
        </title>
      </Helmet>

      <ScrollToTopOnMount />

      <h1>{actions[action || "new"] + "usuarios"}</h1>
      <h2>{id}</h2>

      {/* ------------------------------------------------------------------------------------ CANCELAR */}
      <button
        className="return-button big"
        onClick={() => {
          GS.cache = {};
          navigate(-1);
        }}
      >
        {"<-- Regresar"}
      </button>

      <Form
        method={"post"}
        className={nav.state === "submitting" ? "disabled loading" : ""}
        onSubmit={() => {
          GS.cache = { el: LS };
        }}
      >
        {/* ------------------------------------------------------------------------------------ FORM CONTENTS */}
        <UsuariosForms _store={LS} _disabled={action === "delete"} />

        {/* ------------------------------------------------------------------------------------ GUARDAR CAMBIOS */}
        <button
          className={
            "submit-button big " + (action === "delete" ? "danger" : "primary")
          }
          disabled={nav.state === "submitting"}
        >
          {action === "new"
            ? "Guardar nuevo"
            : action === "edit"
            ? "Guardar cambios"
            : action === "delete"
            ? "Eliminar usuario"
            : "Acción desconocida"}
        </button>
      </Form>
    </div>
  );
};

// ################################ STYLES ################################
const AdminAction = styled(_AdminAction).attrs(
  (props: AdminActionProps): AdminActionProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    .return-button,
    .submit-button {
      display: block;
      min-width: 10rem;
      margin: 0.5rem 2.5rem;
    }

    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default AdminAction;
